import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import { Route, Routes, useNavigate } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import logo from "../assets/logo.png";
import DashboardScreen from "../screen/dashboard";
import CreateRecept from "../screen/createrecept";
import AllReciept from "../screen/allreciept";
import Settings from "../screen/settings";
import ViewRecept from "../screen/viewrecept";
import EstimateForm from "../screen/estimateForm";
import BAButton from "./components/BAButton";
import BAModal from "./components/BAModal";
import Product from "../screen/product";
import ProductForm from "../screen/productform";

// Icons
import ReceiptIcon from '@mui/icons-material/Receipt';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import SettingsIcon from '@mui/icons-material/Settings';
import BalanceSheet from "../screen/balancsheet";
import LogoutIcon from '@mui/icons-material/Logout';
import Estimate from "../screen/estimate";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CategoryIcon from '@mui/icons-material/Category';
import ProductInventory from "../screen/productinventory";
import HumanResources from "../screen/hr";
import TenantUser from "../screen/tanentuser";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import StoreIcon from '@mui/icons-material/Store';
import Feedback from "../screen/feedback";
import CommentIcon from '@mui/icons-material/Comment';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MainLayout() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [openModal, setOpenModal] = React.useState(false)
  const [routeList, setRouteList] = React.useState([
    {
      routeName: "Reciept",
      route: "reciept",
      icon: <ReceiptIcon />
    },
    {
      routeName: "Balance Sheet",
      route: "balancesheet",
      icon: <FormatAlignLeftIcon />
    },
    {
      routeName: "Estimate",
      route: "estimate",
      icon: <ReceiptLongIcon />
    },
    {
      routeName: "Setting",
      route: "setting",
      icon: <SettingsIcon />
    },
    {
      routeName: "Feedback",
      route: "feedback",
      icon: <CommentIcon />
    },
    // {
    //   routeName: "Products",
    //   route: "product",
    //   icon: <CategoryIcon />
    // },
    // {
    //   routeName: "Vendor",
    //   route: "product",
    //   icon: <PeopleAltIcon />
    // },
    // {
    //   routeName: "Human Resources",
    //   route: "hr",
    //   icon: <SensorOccupiedIcon />
    // },
    // {
    //   routeName: "Tanent User",
    //   route: "tanentuser",
    //   icon: <StoreIcon />
    // },
  ]);
  const [filteredList, setFilteredList] = React.useState([]);
  const [userObj, setUserObj] = React.useState({});
  const [openMenu, setOpenMenu] = React.useState(null);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const moveToRoute = (route) => {
    navigate(route);
  };

  let logout = () => {
    localStorage.removeItem("mubashirCurtainToken");
    localStorage.removeItem("mubashirCurtainUser");
    setOpenMenu(!openMenu);
    setOpenModal(false)
    navigate("/login");
  };

  let seachInList = (e) => {
    let arr = routeList.filter((x) =>
      x.routeName.toLowerCase().includes(e.target.value.toLowerCase())
    );
    if (e.target.value == "") {
      setFilteredList([]);
    } else {
      setFilteredList([...arr]);
    }
  };

  React.useEffect(() => {
    if (theme.breakpoints.down('sm')) {
      setOpen(false)
    } else {
      setOpen(true)
    }
    let token = localStorage.getItem('mubashirCurtainToken')
    if (!token) {
      navigate('/login')
    } else {

      // let obj = JSON.parse('mubashirCurtainUser')
      // setUserObj({ ...obj })
    }
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <BAModal modalTitle='Logout !' innerContent={<Box>
        <Typography variant="h5">Are You Sure You want to Logout?</Typography>
        <Box className="d-flex justify-content-around p-3">
          <BAButton onClick={() => {
            setOpenModal(false)
          }} color='inherit' label='No' />
          <BAButton onClick={logout} label='Yes' />
        </Box>
      </Box>} width='35vw' open={openModal} close={(e) => setOpenModal(e)} />
      <CssBaseline />
      <AppBar sx={{ backgroundColor: "#264653" }} position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" noWrap component="div">
            Mubashir Curtain
          </Typography>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          ></Typography>
          {userObj.userName && (
            <div>
              <Tooltip title={userObj.userName}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={() => setOpenMenu(!openMenu)}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
              </Tooltip>
              <Menu
                id="menu-appbar"
                anchorEl={openMenu}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(openMenu)}
                onClose={() => setOpenMenu(!openMenu)}
              >
                <MenuItem onClick={() => setOpenMenu(!openMenu)}>
                  Profile
                </MenuItem>
                <MenuItem onClick={() => setOpenMenu(!openMenu)}>
                  My account
                </MenuItem>
                <MenuItem onClick={() => setOpenModal(true)}>Logout</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <Box className="bgLight">
          <DrawerHeader>
            <img onClick={() => navigate('/')} src={logo} alt="logo" width="50px" className="d-inline-block mx-auto cursor-pointer" />
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
        </Box>
        <Box className="d-flex h-100 flex-column bgLight justify-content-between">
          <Box>
            <List>
              {routeList.map((text, index) => (
                <ListItem
                  onClick={() => moveToRoute(text.route)}
                  key={index}
                  disablePadding
                  sx={{ display: "block" }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      {text.icon || <InboxIcon />}
                    </ListItemIcon>
                    <ListItemText
                      primary={text.routeName}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}

            </List>
          </Box>
          <Box className="p-2 text-center border-top">
            <BAButton onClick={() => setOpenModal(true)} startIcon={<LogoutIcon />} label='Logout' />
          </Box>
        </Box>
      </Drawer>
      <Box className="bg-light main-body" component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Routes>
          <Route path="/" element={<DashboardScreen />} />
          <Route path="createrecept" element={<CreateRecept />} />
          <Route path="createrecept/:id" element={<CreateRecept />} />
          <Route path="reciept" element={<AllReciept />} />
          <Route path="balancesheet" element={<BalanceSheet />} />
          <Route path="setting" element={<Settings />} />
          <Route path="estimate" element={<Estimate />} />
          <Route path="estimateform" element={<EstimateForm />} />
          <Route path="estimateform/:id" element={<EstimateForm />} />
          <Route path="viewrecept/:id" element={<ViewRecept />} />
          <Route path="product" element={<Product />} />
          <Route path="productform" element={<ProductForm />} />
          <Route path="productform/:id" element={<ProductForm />} />
          <Route path="productinventory" element={<ProductInventory />} />
          <Route path="tanentuser" element={<TenantUser />} />
          <Route path="hr" element={<HumanResources />} />
          <Route path="feedback" element={<Feedback />} />
          <Route
            path="*"
            element={<Typography>404 Page Not Found</Typography>}
          />
        </Routes>
      </Box>
    </Box>
  );
}
